import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

import './index.css';
import 'basscss/css/basscss.css';

ReactDOM.render(<App />, document.getElementById('root'));

document.addEventListener('contextmenu', event => {
    if (event && event.target && event.target.tagName === 'IMG') {
        event.preventDefault();
    }
});



// WEBPACK FOOTER //
// ./src/index.js